export const configRadarAmedas = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/JMA_NOWCAS_RADAR_AMEDAS_PRCRIN/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "JMA_NOWCAS_RADAR_AMEDAS_PRCRIN",
      "url": "%expo_tile_gpv_url%/JMA_NOWCAS_RADAR_AMEDAS_PRCRIN_%validtime%/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 3,
        "MaxZoom": 9,
        "YCoordinate": -1,
        "BoundingBox": {
          "West": 120.5,
          "South": 21,
          "East": 149,
          "North": 46
        }
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};

const coverage  = [128, 128, 128, 25];
const clearCoverage = [0, 0, 0, 0];
const palette = [
  coverage,
  [0, 0, 0, 1],
  [0, 255, 255, 120],
  [0, 255, 255, 120],
  [0, 255, 255, 120],
  [0, 255, 255, 120],
  [0, 255, 255, 120],
  [0, 255, 255, 120],
  [0, 255, 255, 120],
  [0, 255, 255, 120],
  [0, 255, 255, 120],
  [0, 144, 255, 120],
  [0, 144, 255, 120],
  [0, 144, 255, 120],
  [0, 144, 255, 120],
  [0, 144, 255, 120],
  [0, 144, 255, 120],
  [0, 144, 255, 120],
  [0, 144, 255, 120],
  [0, 144, 255, 120],
  [0, 144, 255, 120],
  [0, 0, 255, 120],
  [0, 0, 255, 120],
  [0, 0, 255, 120],
  [0, 0, 255, 120],
  [0, 0, 255, 120],
  [0, 0, 255, 120],
  [0, 0, 255, 120],
  [0, 0, 255, 120],
  [6, 207, 34, 120],
  [6, 207, 34, 120],
  [6, 207, 34, 120],
  [6, 207, 34, 120],
  [6, 207, 34, 120],
  [6, 207, 34, 120],
  [6, 207, 34, 120],
  [6, 207, 34, 120],
  [6, 207, 34, 120],
  [6, 207, 34, 120],
  [0, 255, 0, 120],
  [0, 255, 0, 120],
  [0, 255, 0, 120],
  [0, 255, 0, 120],
  [0, 255, 0, 120],
  [0, 255, 0, 120],
  [135, 255, 6, 120],
  [135, 255, 6, 120],
  [135, 255, 6, 120],
  [135, 255, 6, 120],
  [255, 255, 0, 120],
  [255, 255, 0, 120],
  [255, 255, 0, 120],
  [255, 255, 0, 120],
  [255, 255, 0, 120],
  [255, 255, 0, 120],
  [255, 255, 0, 120],
  [255, 255, 0, 120],
  [255, 191, 0, 120],
  [255, 191, 0, 120],
  [255, 191, 0, 120],
  [255, 191, 0, 120],
  [255, 191, 0, 120],
  [255, 191, 0, 120],
  [255, 191, 0, 120],
  [255, 191, 0, 120],
  [255, 165, 0, 120],
  [255, 165, 0, 120],
  [255, 165, 0, 120],
  [255, 165, 0, 120],
  [255, 165, 0, 120],
  [255, 165, 0, 120],
  [255, 165, 0, 120],
  [255, 165, 0, 120],
  [255, 140, 0, 120],
  [255, 140, 0, 120],
  [255, 140, 0, 120],
  [255, 140, 0, 120],
  [255, 140, 0, 120],
  [255, 140, 0, 120],
  [255, 140, 0, 120],
  [255, 140, 0, 120],
  [255, 21, 6, 120],
  [255, 21, 6, 120],
  [255, 21, 6, 120],
  [255, 21, 6, 120],
  [255, 21, 6, 120],
  [255, 21, 6, 120],
  [255, 21, 6, 120],
  [255, 21, 6, 120],
  [255, 0, 0, 120],
  [255, 0, 0, 120],
  [255, 0, 0, 120],
  [255, 0, 0, 120],
  [255, 0, 0, 120],
  [255, 0, 0, 120],
  [255, 0, 0, 120],
  [255, 0, 0, 120],
  [244, 0, 161, 120],
  [244, 0, 161, 120],
  [244, 0, 161, 120],
  [244, 0, 161, 120],
  [244, 0, 161, 120],
  [244, 0, 161, 120],
  [244, 0, 161, 120],
  [244, 0, 161, 120],
  [244, 0, 161, 120],
  [244, 0, 161, 120],
  [244, 0, 161, 120],
  [244, 0, 161, 120],
  [244, 0, 161, 120],
  [244, 0, 161, 120],
  [244, 0, 161, 120],
  [244, 0, 161, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [255, 0, 255, 120],
  [100, 100, 100, 30]
];

export const expoRadarLayerConfig = {
  "Name": "XXX",
  "Renderer": "Image",
  "Attributes": {
    "style": {
      "default": {
        "type": "grayscale_palette",
        "mag_filter": "NEAREST",
        "alternative_color": coverage,
        "palette": palette
      },
      "clear_coverage": {
        "type": "grayscale_palette",
        "mag_filter": "NEAREST",
        "alternative_color": clearCoverage,
        "palette": [clearCoverage, ...palette.slice(1)]
      }
    }
  }
};

export const getLayerConfig = (name) => {
  return {...expoRadarLayerConfig, Name: name}
}
